import Vue from "vue";
import VueRouter from "vue-router";
// import Inicio from '../views/Inicio.vue'
// import Sobre from "../views/Sobre.vue"
// import Ayuda from "../views/Ayuda.vue"
// import Aviso from "../views/Aviso.vue"
// import Uso from "../views/Uso.vue"
// import fraude from "../views/fraude.vue"

// import loan from "../views/loan.vue"
// import complaints from "../views/complaints.vue"
// import fraude from "../views/fraude.vue"

import Inicio from "../views/newPage/Inicio.vue";
import Sobre from "../views/newPage/Sobre.vue";
import Ayuda from "../views/newPage/Ayuda.vue";
import Aviso from "../views/newPage/Aviso.vue";
import Uso from "../views/newPage/Uso.vue";
import fraude from "../views/newPage/fraude.vue";
import libro from "../views/newPage/libro.vue";

import credisolHome from "../h5Views/index.vue";
import h5Home from "../h5Views/mainHome.vue";
import registerInfo from "../h5Views/registerInfo.vue";
import faceIdentify from "../h5Views/faceIdentify.vue";
// import frloanHome from "../h5Views/frloanHome.vue";
// import repaymentPage from "../h5Views/repayment.vue";
import historyList from "../h5Views/historyList.vue";
// import userState from "../h5Views/userState.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Inicio",
  },
  {
    path: "/Inicio",
    name: "Inicio",
    component: Inicio,
  },
  {
    path: "/Sobre",
    name: "Sobre",
    component: Sobre,
  },
  {
    path: "/Ayuda",
    name: "Ayuda",
    component: Ayuda,
  },
  {
    path: "/Aviso",
    name: "Aviso",
    component: Aviso,
  },
  {
    path: "/Uso",
    name: "Uso",
    component: Uso,
  },
  {
    path: "/fraude",
    name: "fraude",
    component: fraude,
  },
  {
    path: "/libro",
    name: "libro",
    component: libro,
  },
  {
    path: "/h5Page",
    name: "h5Page",
    redirect: "home",
    component: credisolHome,
    children: [
      {
        path: "home",
        name: "home",
        component: h5Home,
      },
      {
        path: "registerInfo",
        name: "registerInfo",
        component: registerInfo,
      },
      {
        path: "faceIdentify",
        name: "faceIdentify",
        component: faceIdentify,
      },
      // {
      //   path: "frloanHome",
      //   name: "frloanHome",
      //   component: frloanHome,
      // },
      // {
      //   path: "repaymentPage",
      //   name: "repaymentPage",
      //   component: repaymentPage,
      // },
      {
        path: "historyList",
        name: "historyList",
        component: historyList,
      },
      // {
      //   path: "userState",
      //   name: "userState",
      //   component: userState,
      // },
    ],
  },
];

const router = new VueRouter({
  mode: window.location.host == "www.credisol.pe" ? "history" : "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
